import { Component, Renderer2 } from '@angular/core';
import { SegmentedControlModule, SegmentedItemOptions } from '@usitsdasdesign/dds-ng/segmented-control';
import { Themes, Size } from '@usitsdasdesign/dds-ng/shared';
import { DdsConfigService } from '@usitsdasdesign/dds-ng/shared/dds-config';
import { EComponentsMode, ThemesItem } from './typings';
import { SettingsPanelService } from './settings-panel.service';
import { ContextMenuModule } from '@usitsdasdesign/dds-ng/context-menu';
import { SelectModule } from '@usitsdasdesign/dds-ng/select';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-settings-panel',
    standalone: true,
    imports: [
        CommonModule,
        SegmentedControlModule,
        ContextMenuModule,
        SelectModule
    ],
    templateUrl: './settings-panel.component.html',
    styleUrl: './settings-panel.component.scss'
})
export class SettingsPanelComponent {
    themesList: ThemesItem[] = [
        {
            heading: 'Dark',
            value: Themes.dark,
            colors: ['#000']
        },
        {
            heading: 'Green',
            value: Themes.green,
            colors: ['#26890D']
        },
        {
            heading: 'Blue',
            value: Themes.blue,
            colors: ['#007CB0']
        },
        {
            heading: 'Custom',
            value: 'custom',
            colors: ['#F18200']
        },
        {
            heading: 'Deloitte Digital ',
            value: 'digital',
            colors: ['#86BC25']
        },
    ];

    sizesList: SegmentedItemOptions[] = [
        {
            heading: 'Medium',
            value: Size.md
        },
        {
            heading: 'Small',
            value: Size.sm
        },
        {
            heading: 'Large',
            value: Size.lg
        }
    ];

    headerMode: SegmentedItemOptions[] = [
        {
            icon: 'dds-icon_lightbulb',
            value: EComponentsMode.dark,
            ariaLabel: 'Header Dark Mode'
        },
        {
            icon: 'dds-icon_sun__s__stroke',
            value: EComponentsMode.light,
            ariaLabel: 'Header Light Mode'
        }
    ];

    menuMode: SegmentedItemOptions[] = [
        {
            icon: 'dds-icon_lightbulb',
            value: EComponentsMode.dark,
            ariaLabel: 'Menu Dark Mode'
        },
        {
            icon: 'dds-icon_sun__s__stroke',
            value: EComponentsMode.light,
            ariaLabel: 'Menu Light Mode'
        }
    ];

    isCollapsedPanel: boolean = false;
    headerModeValue = '';
    menuModeValue = '';
    selectedItem = 'dark';
    size = 'md';

    getCircleColor(colors: string[]): string {
        const color1 = colors[0];
        const color2 = colors[1] || color1;

        return `linear-gradient(to right, ${color1} 0%, ${color1} 50%, ${color2} 50%, ${color2} 100%)`;
    }

    constructor(
        private сonfigService: DdsConfigService,
        private settingsPanelService: SettingsPanelService,
        private renderer: Renderer2
    ) {
        const theme = this.settingsPanelService.getItemToStorage('theme') || this.selectedItem;
        const size = this.settingsPanelService.getItemToStorage('size') || this.size;
        const themeForConfig = theme === 'custom' || theme === 'digital' ? Themes.green : theme;

        this.сonfigService.setConfig({ theme: themeForConfig, size: size });
        this.selectedItem = theme;
        this.size = size;
        this.checkCustomTheme(theme);
    }

    ngOnInit(): void {
        this.menuModeValue = this.settingsPanelService.getItemToStorage('menuMode') || 'dark';
        this.headerModeValue = this.settingsPanelService.getItemToStorage('headerMode') || 'dark';
        this.menuModeChanged(this.menuModeValue);
        this.headerModeChanged(this.headerModeValue);
    }

    sizeChanged(selectedSize: string): void {
        this.settingsPanelService.setItemToStorage('size', selectedSize);
        location.reload();
    }

    headerModeChanged(selectedMode: EComponentsMode | string): void {
        this.settingsPanelService.toggleHeaderMode(selectedMode);
        this.settingsPanelService.setItemToStorage('headerMode', selectedMode);
    }

    menuModeChanged(menuModeChanged: EComponentsMode | string): void {
        this.settingsPanelService.toggleMenuMode(menuModeChanged);
        this.settingsPanelService.setItemToStorage('menuMode', menuModeChanged);
    }

    selectTheme(theme: string): void {
        this.settingsPanelService.setItemToStorage('theme', theme);
        location.reload();
    }

    panelColapseToggle(): void {
        this.isCollapsedPanel = !this.isCollapsedPanel;
    }

    private checkCustomTheme(selectedTheme: string): void {
        switch (selectedTheme) {
            case 'custom':
                this.renderer.addClass(document.body, 'custom');
                break;

            case 'digital':
                this.renderer.addClass(document.body, 'digital');
                break;

            default:
                this.renderer.removeClass(document.body, 'custom');
                this.renderer.removeClass(document.body, 'digital');
                break;
        }
    }
}
